import {commitMutation, graphql} from 'react-relay'
import type {Environment, RecordSourceSelectorProxy} from 'relay-runtime'

import {forEachMatchingPendingSuggestion, type SuggestionRef, toSuggestionInput} from '../utils/suggestion-ref'
import type {
  rejectPendingIssueSuggestionsMutation,
  rejectPendingIssueSuggestionsMutation$data,
} from './__generated__/rejectPendingIssueSuggestionsMutation.graphql'

export type RejectSuggestionRef = SuggestionRef

export function commitRejectPendingIssueSuggestionsMutation({
  environment,
  issueId,
  actorId,
  suggestions,
  onError,
  onCompleted,
}: {
  environment: Environment
  issueId: string
  actorId: string
  suggestions: RejectSuggestionRef[]
  onError?: (error: Error) => void
  onCompleted?: (response: rejectPendingIssueSuggestionsMutation$data) => void
}) {
  return commitMutation<rejectPendingIssueSuggestionsMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation rejectPendingIssueSuggestionsMutation($input: RejectPendingIssueSuggestionsInput!) {
        rejectPendingIssueSuggestions(input: $input) {
          clientMutationId
        }
      }
    `,
    variables: {
      input: {
        issueId,
        actorId,
        suggestions: suggestions.map(toSuggestionInput),
      },
    },
    optimisticUpdater: store => markRejected(store, issueId, actorId, suggestions),
    updater: store => markRejected(store, issueId, actorId, suggestions),
    onError: error => onError?.(error),
    onCompleted: response => onCompleted?.(response),
  })
}

function markRejected(
  store: RecordSourceSelectorProxy,
  issueId: string,
  actorId: string,
  suggestions: RejectSuggestionRef[],
) {
  const issue = store.get(issueId)
  if (!issue) return
  const pendingSuggestions = issue.getLinkedRecords('pendingSuggestions')
  if (!pendingSuggestions) return

  for (const suggestion of suggestions) {
    forEachMatchingPendingSuggestion(pendingSuggestions, actorId, suggestion, matched => {
      // Relay stores fields under the schema name (`state`), not the fragment alias.
      matched.setValue('REJECTED', 'state')
    })
  }
}
